import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { webAuthTypes } from 'app/model/linkedservice/web-table.linkedservice';
import { WebCopySource } from 'app/model/pipeline/copysource/web.copysource';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

export const webMetadata: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.webTable.linkedServiceType,
    displayName: stringResources.WebTable_DisplayText,
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-web_table'
    },
    isOnPremises: true,
    isFirstClass: true,
    category: ['ServicesApps'],
    supportDatasetV2: true,
    copySinkTypes: [],
    copySourceTypes: [Metamodel.modelFor(WebCopySource).name],
    controls: [
        {
            type: 'textbox',
            bind: 'url',
            label: stringResources.ModelName_Url,
            isLabelVertical: true,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ]
        },
        {
            type: 'select',
            bind: 'authenticationType',
            label: stringResources.ModelName_AuthenticationType,
            options: [
                {
                    label: stringResources.Anonymous_DisplayText,
                    value: webAuthTypes.Anonymous
                }
            ],
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true,
            defaultValue: webAuthTypes.Anonymous
        }
    ]
};
